import React from "react";
import { FormControl } from "react-bootstrap";
import SurveyField from "../components/SurveyField";
import SurveyHomeCardPreview from "../preview/SurveyHomeCardPreview";

const SurveyDetailsForm = ({ form, errors, readOnly, onChange }) => (
  <div className="survey-builder-top-workspace">
    <section className="survey-builder-details-panel">
      <div className="survey-builder-panel-heading"><div><strong>Survey details</strong><span>Content displayed on the customer Home Card</span></div></div>
      <div className="survey-builder-details-content"><div className="survey-builder-home-grid">
        <SurveyField label="Title" required error={errors.title}><FormControl placeholder="Enter survey title" value={form.title || ""} disabled={readOnly} maxLength={255} onChange={(event) => onChange({ ...form, title: event.target.value })} /></SurveyField>
        <SurveyField label="Description" required error={errors.description}><FormControl componentClass="textarea" rows={3} placeholder="Enter the survey description shown to customers" value={form.description || ""} disabled={readOnly} onChange={(event) => onChange({ ...form, description: event.target.value })} /></SurveyField>
      </div></div>
    </section>
    <section className="survey-builder-home-preview-panel">
      <div className="survey-builder-panel-heading"><div><strong>Home Card preview</strong><span>Customer home screen appearance</span></div><span className="survey-builder-live-badge"><i /> Live preview</span></div>
      <div className="survey-builder-home-preview-stage"><SurveyHomeCardPreview form={form} /></div>
    </section>
  </div>
);

export default SurveyDetailsForm;
